import { useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { useAuth } from "@/auth/useAuth";
import { useConfirmEmailVerification } from "@/hooks/useVerification";
import { extractErrorMessage } from "@/services/axiosConfig";
import "./LoginPage.css";

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const { user } = useAuth();

  const confirm = useConfirmEmailVerification();
  const ran = useRef(false);

  // Dispara a confirmação uma única vez quando há token (StrictMode-safe via ran).
  useEffect(() => {
    if (!token || ran.current) return;
    ran.current = true;
    confirm.mutate(token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const status: "loading" | "success" | "error" = !token
    ? "error"
    : confirm.isSuccess
      ? "success"
      : confirm.isError
        ? "error"
        : "loading";

  const error = !token
    ? "Este link de verificação é inválido ou está incompleto."
    : confirm.isError
      ? extractErrorMessage(confirm.error)
      : null;

  return (
    <div className="login-shell">
      <div className="login-card">
        {status === "loading" && (
          <>
            <h1 className="login-title">Confirmando e-mail…</h1>
            <p className="login-sub">Aguarde um instante.</p>
          </>
        )}

        {status === "success" && (
          <>
            <h1 className="login-title">E-mail confirmado</h1>
            <p className="login-sub">Seu e-mail foi verificado com sucesso.</p>
            <Link to={user ? "/" : "/login"} className="login-link">
              {user ? "Ir para o app" : "Ir para o login"}
            </Link>
          </>
        )}

        {status === "error" && (
          <>
            <h1 className="login-title">Não foi possível confirmar</h1>
            <p className="login-sub">{error ?? "Link inválido ou expirado."}</p>
            <Link to={user ? "/verificar" : "/login"} className="login-link">
              {user ? "Voltar à verificação" : "Ir para o login"}
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
